import ExplainWithAiSaveButtonDisplay from './ExplainWithAiSaveButtonDisplay';
import { LlmSubjectKind } from '../../utils/apollo/graphqlSchema';

interface IProps {
  dashboardBaseId: string;
  currentResultRichText: string;
  trackAction: string;
  trackContext: string;
}

const ExplainWithAiSaveToDashboardButton = ({
  trackAction,
  trackContext,
}: IProps) => {
  // TODO check permissions
  // TODO actually add to the dashboards
  return (
    <ExplainWithAiSaveButtonDisplay
      subjectKind={LlmSubjectKind.Dashboard}
      // onClick={onSave}
      isPermitted={false}
      isDisabled={true}
      trackAction={trackAction}
      trackContext={trackContext}
    />
  );
};

export default ExplainWithAiSaveToDashboardButton;
